import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOrganizations, createOrganization, fetchOrganization, modifyOrganization, deleteOrganizationApi, changeStatus, fetchBusinessTypes, fetchOrganizationTypes } from '../../api/OrganizationApi';

export const getOrganizations = createAsyncThunk('organization/getOrganizations', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchOrganizations(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addOrganization = createAsyncThunk('organization/addOrganization', async (payload, { rejectWithValue }) => {
  try {
    const response = await createOrganization(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getOrganizationDetails = createAsyncThunk('organization/getOrganizationDetails', async (organizationId, { rejectWithValue }) => {
  try {
    const response = await fetchOrganization(organizationId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const updateOrganization = createAsyncThunk('organization/updateOrganization', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyOrganization(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const deleteOrganization = createAsyncThunk('organization/deleteOrganization', async (organizationId, { rejectWithValue }) => {
  try {
    const response = await deleteOrganizationApi(organizationId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('organization/changeDefaultStatus', async (organizationId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(organizationId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getBusinessTypes = createAsyncThunk('setting/getBusinessTypes', async ({payload}, { rejectWithValue }) => {
  try {
      const response = await fetchBusinessTypes(payload);
      return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getOrganizationTypes = createAsyncThunk('setting/getOrganizationTypes', async ({payload}, { rejectWithValue }) => {
  try {
      const response = await fetchOrganizationTypes(payload);
      return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});


const organizationSlice = createSlice({
  name: 'organization',
  initialState: {
    organizations: [],
    organizationDetails: {},
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrganizations.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrganizations.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizations = action.payload;
      })
      .addCase(getOrganizations.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getOrganizationDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getOrganizationDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        state.organizationDetails = action.payload.data;
      })
      .addCase(getOrganizationDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default organizationSlice.reducer;
